const getRgbObjFromString = (color: string): any => {
  if (color && color[0] === "#") {
    const rHex = color.slice(1, 3);
    const gHex = color.slice(3, 5);
    const bHex = color.slice(5, 7);

    return {
      r: parseInt(rHex, 16),
      g: parseInt(gHex, 16),
      b: parseInt(bHex, 16),
      a: 1
    };
  }

  const rgbaArray = color?.match(/\d+(\.\d+)?/g);
  if (rgbaArray && rgbaArray.length >= 4) {
    return {
      r: parseInt(rgbaArray[0], 10),
      g: parseInt(rgbaArray[1], 10),
      b: parseInt(rgbaArray[2], 10),
      a: parseFloat(rgbaArray[3])
    };
  }

  return { r: 0, g: 0, b: 0, a: 1 };
};

export default getRgbObjFromString;
